import operationTypesRealNames from 'constants/operationTypesRealNames';
import { translate } from 'hooks/useTranslate';
import { getOperationSharesCount } from 'modules/transactions/utils/getOperationSharesCount';
import { getOperationAmount } from 'modules/transactions/utils/getOperationAmount';
import { Operation, Society } from 'types';

type MapOperationsToTableProps = {
  operations: Operation[];
  society: Society;
  isReadOnly: boolean;
};

const getOperationName = (operation: Operation) => {
  const operationName = operation?.alias || operation.operationType;
  return translate(operationTypesRealNames[operationName]);
};

export const mapOperationsToTable = ({
  operations,
  society,
  isReadOnly,
}: MapOperationsToTableProps) => {
  if (!operations?.length || !society) return [];

  return operations.map((operation: Operation) => ({
    amount: getOperationAmount(operation, society),
    comments: operation?.comments || '',
    date: operation.date,
    operationName: getOperationName(operation),
    operationType: operation.operationType,
    participations: getOperationSharesCount(operation) || '-',
    reference: operation._id,
    society,
    societyName: society.name,
    transaction: operation,
    isReadOnly,
  }));
};
